import tr, { rec } from '../../locale';
import { MessageRecord, MessageRecordLang } from '../../source';
import { DIV } from '../elements';
import {
    AllInputAttributes,
    inputLongText2,
    inputText,
    TextAreaAttributes,
} from './input';

export type MessageRecordInputOptions<Attrs> = {
    key: string;
    languages: MessageRecordLang[];
    get: () => MessageRecord;
    set: (mr: MessageRecord) => void;
    attrs: Attrs;
};

type ShortMRAttributes = Omit<AllInputAttributes, 'placeholder'> & {
    placeholder: MessageRecord;
};

const mergeShortPlaceholder = (
    attrs: ShortMRAttributes,
    lang: MessageRecordLang,
): AllInputAttributes => ({
    ...attrs,
    placeholder: rec(attrs.placeholder, lang),
});

export const inputShortMessageRecord = ({
    key,
    languages,
    get,
    set,
    attrs,
}: MessageRecordInputOptions<ShortMRAttributes>) =>
    DIV(
        `message-record-input message-record-input-${key}`,
        languages.map(lang =>
            DIV(
                `message-record-input-${key}--${lang}`,
                tr.core(`language-${lang}`),
                inputText({
                    key: `${key}-input--${lang}`,
                    get: () => rec(get(), lang),
                    set: translated => set({ ...get(), [lang]: translated }),
                    attrs: mergeShortPlaceholder(attrs, lang),
                }),
            ),
        ),
    );

type LongMRAttributes = Omit<TextAreaAttributes, 'placeholder'> & {
    placeholder: MessageRecord;
};

const mergeLongPlaceholder = (
    attrs: LongMRAttributes,
    lang: MessageRecordLang,
): TextAreaAttributes => ({
    ...attrs,
    placeholder: rec(attrs.placeholder, lang),
});

export const inputLongMessageRecord = ({
    key,
    languages,
    get,
    set,
    attrs,
}: MessageRecordInputOptions<LongMRAttributes>) =>
    DIV(
        `message-record-input message-record-input-${key}`,
        languages.map(lang =>
            DIV(
                `message-record-input-${key}--${lang}`,
                tr.core(`language-${lang}`),
                inputLongText2({
                    key: `${key}-input--${lang}`,
                    get: () => rec(get(), lang),
                    set: translated => set({ ...get(), [lang]: translated }),
                    attrs: mergeLongPlaceholder(attrs, lang),
                }),
            ),
        ),
    );
